/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcOrgResponse { 
    vmc_org_id?: string;
    vmc_org_name?: string;
    vmc_org_type?: string;
    updated_time?: Date;
    vmc_md5_hash?: string;
    /**
     * vmc properties
     */
    vmc_properties?: object;
}

